import React, {Component} from 'react'

class CTA extends Component {
    constructor(props){
        super(props);

        this.goToContact = this.goToContact.bind(this);
    }

    goToContact(e){
        this.contactLink.click();
    }

    render() {
        return (
            <div style={{textAlign: 'center'}}>
                <a style={{display: 'none'}} href="/#contact" ref={contactLink => this.contactLink = contactLink}>
                </a>
                <button id="ctaButton" onClick={this.goToContact}>{this.props.content}
                    <i className="fa fa-arrow-right" aria-hidden="true" />
                </button>
            </div>
        )
    }
}

export default CTA